import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _30fpsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"30fps"}/>
}
